import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

type EmdrDatePickerProps = {
    id?: string;
    name: string;
    value?: string;
    defaultValue?: string;
    max: string;
    required?: boolean;
    readOnly?: boolean;
    complete?: boolean;
    showValidation?: boolean;
    onChange: (name: string, value: string) => void;
};

export const EmdrDatePicker = ({
    name,
    value,
    defaultValue = '',
    max,
    required = false,
    readOnly = false,
    complete = false,
    showValidation = false,
    onChange,
    id,
}: EmdrDatePickerProps) => {
    const reqValueString = value || defaultValue;

    const parseIsoToDate = (input?: string): Date | null => {
        if (!input) return null;
        const [y, m, d] = input.split('-').map(Number);
        if (!y || !m || !d) return null;
        const dt = new Date(y, m - 1, d);
        return Number.isNaN(dt.getTime()) ? null : dt;
    };

    const formatDateToIso = (date: Date | null): string => {
        if (!date) return '';
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const checkValidString = (input?: string) => input !== undefined && input.trim().length > 0;
    const checkInvalidString = (input?: string) =>
        input !== undefined && (!input || input.trim().length === 0);

    const selectedDate = parseIsoToDate(reqValueString);
    const minDate = new Date(1950, 0, 1);
    const maxDate = parseIsoToDate(max) ?? new Date();
    const isDisabled = readOnly || complete;

    return (
        <div>
            <ReactDatePicker
                id={id}
                selected={selectedDate}
                onChange={(date: Date | null) => onChange(name, formatDateToIso(date))}
                minDate={minDate}
                maxDate={maxDate}
                dateFormat="dd-MM-yyyy"
                placeholderText="DD-MM-YYYY"
                disabled={isDisabled}
                readOnly={isDisabled}
                name={name}
                required={required}
                className={`form-control ${
                    showValidation && checkInvalidString(reqValueString) ? 'is-invalid' : ''
                } ${showValidation && checkValidString(reqValueString) ? 'is-valid' : ''}`}
                isClearable={false}
                showPopperArrow={false}
            />
            {showValidation && checkInvalidString(reqValueString) && (
                <div className="invalid-feedback d-block">Date is required</div>
            )}
        </div>
    );
};
